import { getUnifiedCreditsUsageProductNameKey } from './unifiedCreditsUsageProductLabels';

/** Leads / performance graph chip keys (LMS `premium` + reports) → same i18n keys as credits usage. */
const UNIFIED_GRAPH_PRODUCT_LABEL_BY_TAB_KEY = {
  premium: 'unifiedBadgeNormal',
  hot: 'unifiedBadgeFeatured',
  superhot: 'unifiedBadgeElite',
};

/**
 * When unified listings UX is on: "All" stays `All`; Basic/Hot/Signature chips use normal/featured/elite copy.
 * Sets both `label` and `title` when present on the tab object (reports use `label`, LMS graph uses `title`).
 */
export const unifyGraphProductTabs = (tabs, enabled) => {
  const list = (tabs || []).map((t) => ({ ...t }));
  if (!enabled) return list;

  return list.map((tab) => {
    if (tab.key === 'all') {
      return { ...tab, label: 'All', title: 'All' };
    }
    const i18nKey = UNIFIED_GRAPH_PRODUCT_LABEL_BY_TAB_KEY[tab.key];
    return i18nKey ? { ...tab, label: i18nKey, title: i18nKey } : tab;
  });
};

/** Only Basic / Hot / Signature product breakdown tiles use unified wording; all other tiles stay unchanged. */
const SLUGS_WITH_UNIFIED_DASHBOARD_LABEL = new Set([
  'basic-listing',
  'basic-listing-dubizzle',
  'hot-listing',
  'signature-listing',
]);

const normalizeSlug = (slug) => (typeof slug === 'string' ? slug.replace(/_/g, '-') : '');

/** Dashboard listing breakdown tiles: same E/F icons as unified upsell; basic unchanged. Icon string resolves via `svg`/`Icon`. */
export const getUnifiedListingBreakdownProductIconKey = (item, isUnifiedListingsEnabled) => {
  if (!isUnifiedListingsEnabled || !item?.slug) return null;
  const slugNorm = normalizeSlug(item.slug);
  if (slugNorm === 'hot-listing' || slugNorm === 'feature') return 'UnifiedFeaturedIcon';
  if (slugNorm === 'signature-listing' || slugNorm === 'elite-listing') return 'UnifiedEliteIcon';
  if (slugNorm === 'boost-to-top' || slugNorm === 'refresh') return 'UnifiedBoostToTopIcon';
  return null;
};

/**
 * Returns an i18n key for unified product labels (unifiedBadgeNormal / unifiedBadgeFeatured / unifiedBadgeElite), or null.
 */
export const resolveUnifiedListingBreakdownTitleKey = (item, isUnifiedListingsEnabled) => {
  if (!isUnifiedListingsEnabled || !item?.slug) return null;
  const slugNorm = normalizeSlug(item.slug);
  if (!SLUGS_WITH_UNIFIED_DASHBOARD_LABEL.has(slugNorm)) return null;
  return getUnifiedCreditsUsageProductNameKey(item.slug) ?? null;
};
